export default "__VITE_ASSET__e68d059b__"